import { Box } from "@mui/material";
import { RefObject } from "react";
import {
    ProjectDetailDto,
    ProjectRelatedEntitiesContainerDto,
} from "../../../../api/psc";
import { Spinner } from "../../../../components/exports";
import ProjectPrintItem from "../../components/ProjectPrintItem";

type TProps = {
    projectsReady: boolean;
    baseInfo: ProjectRelatedEntitiesContainerDto;
    projectDetails: ProjectDetailDto[];
    printContentRef: RefObject<HTMLDivElement>;
};

export default function PrintProjectsView({
    baseInfo,
    projectDetails,
    projectsReady,
    printContentRef,
}: TProps) {
    return (
        <Box
            sx={{
                // Ensure content can flow across multiple pages in print
                "@media print": {
                    height: "auto !important",
                    overflow: "visible !important",
                    pageBreakInside: "auto",
                },
            }}
        >
            {!projectsReady && <Spinner />}

            {projectsReady && (
                <Box
                    ref={printContentRef}
                    sx={{
                        // Remove height restrictions in print mode
                        "@media print": {
                            height: "auto !important",
                            overflow: "visible !important",
                            pageBreakInside: "auto",
                        },
                    }}
                >
                    {/*this is required by the server as it will wait for this element to be available*/}
                    <div id="print-ready" />

                    {projectDetails.map((p, i) => {
                        return (
                            <Box
                                sx={{
                                    breakInside: "avoid",
                                    pageBreakInside: "avoid",
                                    "@media print": {
                                        breakInside: "avoid",
                                        pageBreakInside: "avoid",
                                    },
                                }}
                                key={p.hashId}
                            >
                                <ProjectPrintItem
                                    project={p}
                                    baseInfo={baseInfo}
                                />
                            </Box>
                        );
                    })}
                </Box>
            )}
        </Box>
    );
}
